import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

function amplitudeHost(region?: string): string {
  return region === "eu" ? "analytics.eu.amplitude.com" : "amplitude.com";
}

export const amplitude = defineConnector({
  identifier: "amplitude",
  name: "Amplitude",
  tagLine: "Product analytics platform",
  keywords: "product analytics cohorts events funnels retention behavioral",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://([^/]*\\.)?amplitude\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.apiKey,
      password: app.secret.secretKey,
    }),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your Amplitude project, navigate to **Settings > Projects > [Your Project]** and find your API Key and Secret Key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "configuration", field: "apiKey" },
          helperText: "Your Amplitude project API key",
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
          helperText: "Your Amplitude project secret key",
        },
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: "us",
          target: { kind: "configuration", field: "region" },
          helperText:
            "Choose the region where your Amplitude project is hosted.",
          options: [
            { label: "US (amplitude.com)", value: "us" },
            { label: "EU (analytics.eu.amplitude.com)", value: "eu" },
          ],
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ region }) =>
      `https://${amplitudeHost(region)}/api/3/cohorts?limit=1`,
  },
  publicEnvVars: ({ region }) => ({
    AMPLITUDE_REGION: region || "",
  }),
});
